import { PRIVATE_SAVED_DASHBOARDS_KEY, PUBLIC_SAVED_DASHBOARDS_KEY } from '../../utils';
import Pulse5DashboardColumns from './Pulse5DashboardColumns';
import Pulse5PublicDashboardColumns from './Pulse5PublicDashboardColumns';

const DashboardColumns = {
  [PRIVATE_SAVED_DASHBOARDS_KEY]: Pulse5DashboardColumns,
  [PUBLIC_SAVED_DASHBOARDS_KEY]: Pulse5PublicDashboardColumns,
};

export default DashboardColumns;
